module.exports = __webpack_public_path__ + "static/media/ny-che-routes-mobile.c469fc0f.png";